'use client'

import { Cell, Spacer, Text } from '@vinted/web-ui'

import { useSession } from '@marketplace-web/shared/session-data'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

import { TranslationControl, Status } from '@marketplace-web/i18n/translations-feature'
import { useConversationContext } from '@marketplace-web/messaging/conversation-providers-feature'

const ConversationTranslationButton = () => {
  const { conversation, translateConversationRequest } = useConversationContext()
  const translate = useTranslate('conversation.translation')

  const isTranslated = conversation?.isTranslated
  const conversationId = conversation?.id
  const userId = useSession().user?.id

  const handleTranslate = (newIsTranslated: boolean) => {
    if (!userId || !conversationId) return

    translateConversationRequest({ conversationId, translate: !newIsTranslated })
  }

  const renderTranslateButton = (status: Status) => {
    const messageTheme = status === Status.Translating ? undefined : 'primary'

    return (
      <div className="u-flexbox u-align-items-center u-justify-content-center u-flex-direction-column">
        <Text as="span" text={translate(status)} theme={messageTheme} />
        {status === Status.Translated && (
          <>
            <Spacer size="small" />
            <Text as="h3" text={translate('translated_by')} type="subtitle" />
          </>
        )}
      </div>
    )
  }

  if (!conversationId) return null

  return (
    <div className="u-flexbox u-justify-content-center" data-testid="translate-conversation-button">
      <Cell>
        <TranslationControl
          isTranslated={isTranslated}
          autotranslate={false}
          onClick={handleTranslate}
          tracking={{
            target: 'translate_message',
            targetDetails: conversationId.toString(),
          }}
          renderButton={renderTranslateButton}
        />
      </Cell>
    </div>
  )
}

export default ConversationTranslationButton
